import classNames from 'classnames';
import Typography from 'components/generics/texts/Typography';
import Link from 'next/link';
import DocSign from 'public/assets/icons/doc_sign.svg';
import React, { HTMLAttributes } from 'react';
import classes from './index.module.scss';

interface Props extends HTMLAttributes<HTMLDivElement> {
  title: string;
  uri?: string;
  subtitle?: string;
  Icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  iconContainerClassName?: string;
  iconClassName?: string;
}

const DocumentRow = ({
  title,
  uri,
  subtitle,
  Icon,
  iconContainerClassName,
  iconClassName,
}: Props) => {
  const FinalIcon = Icon || DocSign;

  return (
    <Link
      href={uri || ''}
      target="_blank"
      className={classes.row}
    >
      <div
        className={classNames(classes.iconContainer, iconContainerClassName)}
      >
        <FinalIcon className={classNames(classes.icon, iconClassName)} />
      </div>
      <div className={classes.textContainer}>
        <Typography>{title}</Typography>
        {subtitle && (
          <Typography className={classes.subtitle}>{subtitle}</Typography>
        )}
      </div>
    </Link>
  );
};

export default DocumentRow;
